var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file"},[_c('label',{staticClass:"file-label"},[_c('input',{ref:"newImage",staticClass:"file-input",attrs:{"type":"file"},on:{"change":function($event){_vm.uploadImage()}}}),_c('span',{staticClass:"file-cta button",class:_vm.isUploading ? 'is-loading' : ''},[_c('span',{staticClass:"file-label"},[_vm._v(_vm._s(_vm.caption))])])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3210836c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/FileUploadButton.vue
// module id = null
// module chunks = 